import React from 'react';
import {
  Box,
  Typography,
  Link,
} from '@mui/material';

/**
 * Footer-Komponente für die Anwendung
 * Enthält Copyright-Informationen
 */
const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        backgroundColor: 'transparent',
        borderTop: '1px solid',
        borderColor: 'grey.300',
      }}
    >
      <Typography 
        variant="body2" 
        align="center" 
        sx={{
          color: "text.secondary"
        }}
      >
        © 2025{' '}
        <Link
          href="https://ein-bock.de"
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
          sx={{
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          ein-bock UG
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
